import { useNavigate } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import { Banner, OutlineCard, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';
import { InvitationMessage } from './InvitationMessage';
import { useAcceptEarlyAssessmentRequest as useAcceptEarlyAssessmentRequest } from 'src/api/commands';

const AssessmentInvitation: React.FC<{}> = () => {
  const navigate = useNavigate();
  const {
    earlyAssessment,
    submissionId,
    submissionContext,
    invalidateAssessmentContextData,
    organizationId
  } = useAssessmentData();
  const {
    caseData: { acceptance, editorialRequest }
  } = earlyAssessment;

  // Peer Review Accept Invitation Mutations
  const queryKey = ['early-assessment-data', { id: earlyAssessment.id }];
  const acceptEarlyAssessmentRequestMutation = useAcceptEarlyAssessmentRequest({
    submissionId,
    organizationId,
    assessmentId: earlyAssessment.id,
    submissionContextId: submissionContext.id,
    queryKey,
    subtype: 'accept'
  });

  const declineEarlyAssessmentRequestMutation = useAcceptEarlyAssessmentRequest(
    {
      submissionId,
      organizationId,
      assessmentId: earlyAssessment.id,
      submissionContextId: submissionContext.id,
      queryKey,
      subtype: 'decline'
    }
  );

  const acceptInvitation = async () => {
    await acceptEarlyAssessmentRequestMutation.mutateAsync();
    invalidateAssessmentContextData();
  };

  const declineInvitation = async () => {
    await declineEarlyAssessmentRequestMutation.mutateAsync();
    invalidateAssessmentContextData();
    navigate('/app/assessments?status=active-assessments');
  };

  return (
    <Flex>
      {(!acceptance || acceptance === 'decline') && (
        <OutlineCard borderless padding={4} width="100%">
          <Flex flexDirection="column" gap={4}>
            {acceptance === 'decline' ? (
              <Banner
                variant="error"
                heading="You have declined this invitation"
                content="We appreciate your consideration and hope to collaborate on future opportunities. No further action is required on your part for this review process."
              />
            ) : (
              <>
                <InvitationMessage editorialRequest={editorialRequest} />
                <Flex justifyContent="flex-end" gap={2} marginTop={6}>
                  <Button
                    size="context"
                    variant="caution"
                    onClick={declineInvitation}
                    disabled={acceptEarlyAssessmentRequestMutation.isLoading}
                  >
                    <FontAwesomeIcon icon={faBan} />
                    Decline
                  </Button>
                  <Button
                    size="context"
                    variant="primary"
                    onClick={acceptInvitation}
                    isLoading={acceptEarlyAssessmentRequestMutation.isLoading}
                    isDisabled={acceptEarlyAssessmentRequestMutation.isLoading}
                    disabled={acceptEarlyAssessmentRequestMutation.isLoading}
                  >
                    <FontAwesomeIcon icon={faCheck} />
                    Accept
                  </Button>
                </Flex>
              </>
            )}
          </Flex>
        </OutlineCard>
      )}
    </Flex>
  );
};

export default AssessmentInvitation;
